import React from "react";
import styles from "./loadingDots.module.scss";
const LoadingDots = () => {
    return (React.createElement("div", { "data-testid": "loading-dots", className: styles.root },
        React.createElement("div", { className: styles.loader },
            React.createElement("div", { className: styles.dot }),
            React.createElement("div", { className: styles.dot }),
            React.createElement("div", { className: styles.dot }))));
};
export default LoadingDots;
//# sourceMappingURL=LoadingDots.js.map